import React from 'react';
import { Button, Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import { ResumeMember } from './ResumeMember';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { communityActions } from '../../../core/community-search/actions';
import { useDispatch, useSelector } from 'react-redux';
import LoadingIndicator from '../loading-indicator';

export const CommunityResults = ({ filters, setFilters }) => {
    const dispatch = useDispatch();
    const { data } = useSelector(state => state.community)
    const { isPending } = useSelector(state => state.community)

    const goToPage = (page) => {
        dispatch(communityActions.searchMemberByFilters(data.search ? data.search : {}, page))
    }

    const calculatePageNumber = (position) => {
        if (data && data.current_page) {
            const { current_page, total_pages } = data;
            const isNearStart = current_page <= 3;
            const isNearEnd = current_page + 2 >= total_pages;

            let page;
            if (isNearStart) {
                page = position;
            } else if (isNearEnd) {
                page = total_pages - (5 - position);
            } else {
                page = current_page + (position - 3);
            }
            return total_pages > 5 ? page : position;
        }
    }

    const deleteFilter = (id, type) => {
        let filter = filters
        filter.splice(filter.map(function (item) {
            if(item.type === type) return item.id
        }).indexOf(id), 1)
        setFilters([...filter])
    }

    return (
        <>
            {filters.length > 0 &&
                <div className="d-flex flex-wrap results-items mb-3">
                    {filters && filters.map((filter, index) => {
                        return <Button key={index} onClick={() => deleteFilter(filter.id, filter.type)} size="sm" color="transparent" className="px-2 pr-4 text-left mr-3">{filter.name}</Button>
                    })}
                </div>
            }

            <div className="border rounded">
                <div className='p-3 d-flex justify-content-between border-bottom'>
                    <div><h6 className="font-weight-semibold mb-0">Member name</h6></div>
                    <div><h6 className="font-weight-semibold mb-0 text-center mr-4">Thinking Talents</h6></div>
                    <div><h6 className="font-weight-semibold mb-0 text-center">Mind Patterns</h6></div>
                </div>

                { data && !isPending && data.users && data.users.map(user => {
                    return <ResumeMember key={user.id} user={user} />
                })}
            </div>

            {data && data.current_page && data.total_pages !== null && data.search && data.total_pages > 1 &&
                <Pagination className="mt-auto pt-3" cssModule={{ 'pagination': 'pagination justify-content-center align-items-center' }}>
                    <PaginationItem disabled={(data.current_page === 1)}>
                        <PaginationLink previous onClick={() => goToPage(data.current_page - 1)}><FontAwesomeIcon icon={faChevronLeft} /></PaginationLink>
                        </PaginationItem>

                    {data.current_page > 3 && data.total_pages > 5 && <>
                        <PaginationItem> <PaginationLink onClick={() => goToPage(1)}> {1} </PaginationLink></PaginationItem>
                        <PaginationItem> <PaginationLink > ... </PaginationLink></PaginationItem>
                    </>
                    }

                    {calculatePageNumber(1) <= data.total_pages && <PaginationItem disabled={calculatePageNumber(1) > data.total_pages} active={(data.current_page === calculatePageNumber(1))}>  <PaginationLink onClick={() => goToPage(calculatePageNumber(1))}>   {calculatePageNumber(1)}  </PaginationLink></PaginationItem>}
                    {calculatePageNumber(2) <= data.total_pages && <PaginationItem disabled={calculatePageNumber(2) > data.total_pages} active={(data.current_page === calculatePageNumber(2))}>  <PaginationLink onClick={() => goToPage(calculatePageNumber(2))}>   {calculatePageNumber(2)}  </PaginationLink></PaginationItem>}
                    {calculatePageNumber(3) <= data.total_pages && <PaginationItem disabled={calculatePageNumber(3) > data.total_pages} active={(data.current_page === calculatePageNumber(3))}>  <PaginationLink onClick={() => goToPage(calculatePageNumber(3))}>   {calculatePageNumber(3)}  </PaginationLink></PaginationItem>}
                    {calculatePageNumber(4) <= data.total_pages && <PaginationItem disabled={calculatePageNumber(4) > data.total_pages} active={(data.current_page === calculatePageNumber(4))}>  <PaginationLink onClick={() => goToPage(calculatePageNumber(4))}>   {calculatePageNumber(4)}  </PaginationLink></PaginationItem>}
                    {calculatePageNumber(5) <= data.total_pages && <PaginationItem disabled={calculatePageNumber(5) > data.total_pages} active={(data.current_page === calculatePageNumber(5))}>  <PaginationLink onClick={() => goToPage(calculatePageNumber(5))}>   {calculatePageNumber(5)}  </PaginationLink></PaginationItem>}

                    {calculatePageNumber(5) + 1 <= data.total_pages && <>
                        <PaginationItem> <PaginationLink > ... </PaginationLink></PaginationItem>
                        <PaginationItem> <PaginationLink onClick={() => goToPage(data.total_pages)}> {data.total_pages} </PaginationLink></PaginationItem>
                    </>
                    }

                    <PaginationItem disabled={(data.current_page === data.total_pages)} ><PaginationLink next onClick={() => goToPage(data.current_page + 1)}><FontAwesomeIcon icon={faChevronRight} /></PaginationLink></PaginationItem>
                    {/* <PaginationItem disabled={(data.current_page === data.total_pages)} ><PaginationLink className="text-nowrap" last onClick={() => goToPage(data.total_pages)} children={[<><FontAwesomeIcon icon={faChevronRight} /><FontAwesomeIcon icon={faChevronRight} /></>]} /></PaginationItem> */}
                </Pagination>
            }

            {isPending &&
                <LoadingIndicator />
            }

        </>
    )
}